import handle_logged_out from '@/helpers/handle_logged_out.js'

export default async function (response, router, store) {
  if (response.status === 409) {
    const data = await response.json()

    handle_logged_out(data.data.report_token, store, router)
  }
}
